import React from 'react';
import {Outlet} from "react-router-dom";
import useTitle from "../../../../hooks/TitleManager";
const Contract = () => {
    useTitle({ title: "Contrats" });
    return (
        <>
            <Outlet/>
        </>
    );
};

export default Contract;